import * as React from 'react';
import { useSelector } from 'react-redux';

import { getNewbuildingInfo } from '../../selectors/newbuildingInfo';
import { EmptyListQuestions } from '../../components/EmptyListQuestions';

export const EmptyListQuestionsContainer = (): React.JSX.Element => {
  const { newbuildingName } = useSelector(getNewbuildingInfo);

  return <EmptyListQuestions newbuildingName={newbuildingName} />;
};
